import { API } from "../../../utils";

// Returns the full response (not just the data) so the caller can read the PDF headers
export const exportSalesVatReportApi = async (params) => {
  const response = await API.get("reports/sales-vat/export", {
    params,
    responseType: "blob",
  });
  return response;
};
